import Auth from '@js/plugins/auth';

export function abortIfNotPermitted(permission, next) {
    if (Auth.hasPermissionTo(permission)) {
        next();
        return;
    }

    next(false);
}

/**
 * Only allow access if:
 * - The user is from Batcave OR
 * - The account have a subscription and the user got permission
 */
export function abortIfRequiresSubscription(permission, next) {
    const adminCanManage = Auth.hasPermissionTo('admin_manage_outlets');

    const userCanManage =
        Auth.hasPermissionTo(permission) && Auth.hasSubscription();

    if (adminCanManage || userCanManage || Auth.canExtendAccount()) {
        next();
        return;
    }

    next(false);
}



// WEBPACK FOOTER //
// ./resources/assets/js/router/utils.js